import { render, staticRenderFns } from "./MovementRouteLessonDetailTable.vue?vue&type=template&id=49236080&scoped=true"
import script from "./MovementRouteLessonDetailTable.vue?vue&type=script&lang=js"
export * from "./MovementRouteLessonDetailTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49236080",
  null
  
)

export default component.exports